import React, { useState } from "react";
import axios from "axios";

const AiController = () => {
  const [prompt, setPrompt] = useState("");
  const [status, setStatus] = useState("");

  // --- CONFIGURATION ---
  // 1. If running on the SAME computer, use localhost:
  const LOCAL_URL = "https://c12870bcd1aa.ngrok-free.app/api/command";

  // 2. If running from a phone or different network, use your Ngrok URL:
  // const NGROK_URL = "https://YOUR-NGROK-URL.ngrok-free.app/api/command";

  const API_URL = LOCAL_URL; // Change this to NGROK_URL if needed
  // ---------------------

  const handleSend = async () => {
    if (!prompt.trim()) return;

    setStatus("Sending command...");

    try {
      const response = await axios.post(API_URL, {
        prompt: prompt,
      });

      // The API returns { status: "success", message: "Command queued" }
      if (response.data.status === "success") {
        setStatus(`✅ Sent! AI is processing: "${prompt}"`);
        setPrompt(""); // Clear input box
      } else {
        setStatus(`⚠️ Server Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Connection Error:", error);
      setStatus("❌ Error: Could not connect to AI. Is main.py running?");
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Jarvis Command Center</h1>

      <div style={styles.inputGroup}>
        <input
          type="text"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Type a command (e.g., open youtube)..."
          style={styles.input}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <button onClick={handleSend} style={styles.button}>
          Send
        </button>
      </div>

      <p style={styles.status}>{status}</p>
    </div>
  );
};

// Simple CSS Styles
const styles = {
  container: {
    maxWidth: "600px",
    margin: "50px auto",
    padding: "20px",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  title: {
    color: "#333",
    marginBottom: "20px",
  },
  inputGroup: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
  },
  input: {
    flex: 1,
    padding: "12px",
    fontSize: "16px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  status: {
    marginTop: "20px",
    fontSize: "14px",
    color: "#555",
    minHeight: "20px",
  },
};

export default AiController;
